const angular = require('angular');
const { merge } = require('lodash');

class HeaderSearchController {
    constructor($state, $stateParams, $q, $element, breakpointsService, moveFocus, settings, searchService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.$element = $element;
        this.breakpointsService = breakpointsService;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.searchService = searchService;
    }

    $onInit() {
        this.searchText = this.$stateParams.searchTerm || '';
        this.isActive = false;
        this.sfSearchActive = this.sfSearchActive !== undefined ? this.sfSearchActive : false;
    }

    getItems() {
        return this.settings.search.searchSuggestionThrottleTimeout < 0
            ? this.$q.when([])
            : this.searchService.getSearchSuggestion(this.searchText).then(response => response.SearchSuggestion);
    }

    search(searchOptions) {
        const options = merge({
            enter: false,
            select: false,
        }, searchOptions);
        this.searchService.isHeaderSearch = true;
        this.searchService.isAutocompleteSearch = options.select;
        this.$state.go('shop.search', { searchTerm: this.searchText }, { inherit: false, reload: true });
    }

    toggleSearch() {
        if (this.breakpointsService.isSmallFormat()) {
            this.sfSearchActive = !this.sfSearchActive;
            if (this.sfSearchActive) {
                if (angular.isFunction(this.searchToggledOn)) {
                    this.searchToggledOn();
                }

                // Cannot use movefocus as it uses timeouts internally
                // iOS only allows focus moving if the control directly says to do so
                this.$element.find('#searchBox').toggleClass('is-open', true);
                this.$element.find('#headerSearch').focus();
            }
        }
    }
}

const headerSearchComponentDefinition = {
    bindings: {
        searchToggledOn: '&?',
        sfSearchActive: '=?',
    },
    controller: ['$state', '$stateParams', '$q', '$element', 'BreakpointsService', 'MoveFocus', 'Settings', 'SearchService', HeaderSearchController],
    template: require('./header-search.component.html').trim(),
};

module.exports = {
    HeaderSearchController,
    headerSearchComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/header-search.component.js